import { useCallback, useEffect, useRef, useState } from "react";

/**
 * One player shared by every clip on a review card, so starting a paragraph stops the turn that
 * was already talking. Cards hold many clips — a player each would mean overlapping playback.
 */
export function useReviewAudio() {
  const [playingUrl, setPlayingUrl] = useState<string | null>(null);
  const playerRef = useRef<HTMLAudioElement | null>(null);

  useEffect(
    () => () => {
      playerRef.current?.pause();
      playerRef.current = null;
    },
    []
  );

  const toggle = useCallback(
    (url: string | null) => {
      if (!url) return;

      playerRef.current?.pause();
      if (playingUrl === url) {
        setPlayingUrl(null);
        return;
      }

      const player = new Audio(url);
      player.onended = () => setPlayingUrl(null);
      player.onerror = () => setPlayingUrl(null);
      playerRef.current = player;
      setPlayingUrl(url);
      player.play().catch(() => setPlayingUrl(null));
    },
    [playingUrl]
  );

  return { playingUrl, toggle };
}
